reIsBadHex